import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { CasosService } from './casos.service';
import { Caso } from './casos.model';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from '../core/service/notifications.service';
import { AuthenticationService } from '../core/service/auth.service';
import { User } from '../core/models/auth.models';

@Component({
  selector: 'app-info-general',
  templateUrl: './info-general.component.html',
  styleUrls: ['./info-general.component.scss']
})
export class InfoGeneralComponent implements OnInit {

  @Output() refreshCase = new EventEmitter<void>();

  caso!: Caso;
  loaded: boolean = false;
  error: string = '';
  estadoExpediente: string | undefined;

  loggedInUser: User | null = {};
  disableOptions: boolean = true;

  showConfirmChangeModal: boolean = false; // Controla la visibilidad del modal
  previousEstado: string | undefined; // Almacena el estado previo

  constructor(
    private casosService: CasosService,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    const id_caso = this.route.snapshot.paramMap.get('id');
    if (id_caso) {
      this.casosService.getCaso(id_caso).subscribe({
        next: (caso) => {
          this.estadoExpediente = caso.estado;
          this.previousEstado = caso.estado; // Guardar el estado inicial

          // Asegurarse de que el objeto caso esté inicializado
          this.caso = caso || {};

          // Convertir fecha_solicitud al formato YYYY-MM-DD
          if (caso.fecha_solicitud) {
            this.caso.fecha_solicitud = new Date(caso.fecha_solicitud).toISOString().split('T')[0];
          }

          // Convertir fecha_notificación laudo al formato YYYY-MM-DD
          if (caso.fecha_notificacion_laudo) {
            this.caso.fecha_notificacion_laudo = new Date(caso.fecha_notificacion_laudo).toISOString().split('T')[0];
          }
          // Convertir fecha_convenio_arbitral al formato YYYY-MM-DD
          if (caso.fecha_convenio_arbitral) {
            this.caso.fecha_convenio_arbitral = new Date(caso.fecha_convenio_arbitral).toISOString().split('T')[0];
          }
          // Convertir fecha_prevista_laudo al formato YYYY-MM-DD
          if (caso.fecha_prevista_laudo) {
            this.caso.fecha_prevista_laudo = new Date(caso.fecha_prevista_laudo).toISOString().split('T')[0];
          }
          // Convertir fecha_cierre_financiero al formato YYYY-MM-DD
          if (caso.fecha_cierre_financiero) {
            this.caso.fecha_cierre_financiero = new Date(caso.fecha_cierre_financiero).toISOString().split('T')[0];
          }
          
          this.caso = caso;

          // Saco el usuario logueado
          this.authService.currentUser().subscribe(user => {
            this.loggedInUser = user;
            // Realiza cualquier otra operación que necesites con loggedInUser aquí dentro.
            if (user?.nivel_acceso) {
              // Si soy admin no deshabilito opciones
              if (user.nivel_acceso == "ADMIN") {
                this.disableOptions = false;
              }
              this.loaded = true;
            }
          }, error => {
            console.error('Error al obtener el usuario actual:', error);
            // Maneja el error, por ejemplo, mostrando un mensaje al usuario.
          });



        },
        error: (error) => {
          console.error('Error al cargar el caso:', error);
          this.error = error;
          this.loaded = false;
        }
      });
    }
  }

  isCaseClosed(): boolean {
    const estadosCerrados = ['CERRADO_LAUDO', 'CERRADO_ACUERDO', 'CERRADO_OTROS', 'CERRADO_REENVIO'];
    return estadosCerrados.includes(this.estadoExpediente ?? '');
  }


  onSubmit(f: any): void {
    if (f.valid) {
      if (this.caso.estado !== this.previousEstado) {
        // Si el estado ha cambiado, mostrar el modal
        this.showConfirmChangeModal = true;
      } else {
        // Si no cambió, guardar directamente
        this.saveChanges();
      }
    }
  }
  
  confirmStateChange(): void {
    this.showConfirmChangeModal = false; // Cerrar el modal
    this.saveChanges(); // Guardar los cambios
  }
  
  closeStateChangeModal(): void {
    this.showConfirmChangeModal = false; // Cerrar el modal sin guardar
    this.caso.estado = this.previousEstado; // Restaurar el estado previo
  }

  saveChanges(): void {
    if (this.caso.id) {
      const updatedData: any = {
        numero_expediente: this.caso.numero_expediente,
        fecha_solicitud: this.caso.fecha_solicitud,
        ...(this.caso.fecha_notificacion_laudo ? { fecha_notificacion_laudo: this.caso.fecha_notificacion_laudo } : {}),
        ...(this.caso.fecha_convenio_arbitral ? { fecha_convenio_arbitral: this.caso.fecha_convenio_arbitral } : {}),
        ...(this.caso.fecha_prevista_laudo ? { fecha_prevista_laudo: this.caso.fecha_prevista_laudo } : {}),
        ...(this.caso.fecha_cierre_financiero ? { fecha_cierre_financiero: this.caso.fecha_cierre_financiero } : {}),
        estado: this.caso.estado,
        tipo_tribunal: this.caso.tipo_tribunal
      };
  
      this.casosService.updateCaso(this.caso.id, updatedData).subscribe({
        next: () => {
          const updateCasoSuccessMessage: string = $localize`:@@updateCasoSuccessMessage:Datos guardados correctamente`;
          this.notificationsService.showSuccessNotification(updateCasoSuccessMessage);
          this.refreshCase.emit();
  
          const estadosCerrados = ['CERRADO_LAUDO', 'CERRADO_ACUERDO', 'CERRADO_OTROS', 'CERRADO_REENVIO'];
          if (estadosCerrados.includes(updatedData.estado)) {
            this.disableOptions = true;
          }
  
          this.previousEstado = updatedData.estado; // Actualizar el estado previo
        },
        error: (error) => {
          console.error('Error al guardar los cambios:', error);
        }
      });
    }
  }
}
